import { LogicStepParameterType } from '@wdx/shared/swagger-gen';

export const PrimitiveKinds = [
    LogicStepParameterType.Primitive,
    LogicStepParameterType.Boolean,
    LogicStepParameterType.Date,
    LogicStepParameterType.Decimal,
    LogicStepParameterType.Integer,
    LogicStepParameterType.String,
    LogicStepParameterType.Text,
];

export const ExtendedPrimitiveKinds = [
    ...PrimitiveKinds,
    'Currency',
    'DateTime',
    'Identifier',
    'VirtualReference',
    'Reference',
    'Duration',
    'MultilineText',
];

export const LookupKinds = [
    LogicStepParameterType.Select,
    LogicStepParameterType.Lookup,
    LogicStepParameterType.Tag,
    LogicStepParameterType.ApiSource,
    LogicStepParameterType.Options,
    LogicStepParameterType.Enum,
];

export const SegmentedKinds = [
    LogicStepParameterType.RelativeParty,
    LogicStepParameterType.RelativeDate,
];
